import { DependencyList, useEffect, useState } from 'react'
import urlJoin from 'url-join'

import useAsyncEffect from './useAsyncEffect'
import { useAuth0 } from '../services/auth'
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios'

const GATSBY_API_URL = process.env.GATSBY_API_URL || 'http://localhost:3000/'

export async function fetchWithTimeout(
  path: string,
  options: AxiosRequestConfig = {},
  accessToken: string,
  timeout = 5000,
  params,
): Promise<AxiosResponse> {
  const controller = new AbortController()
  const id = setTimeout(() => controller.abort(), timeout)

  const response = await axios.request({
    method: 'GET',
    url: urlJoin(GATSBY_API_URL, path),
    headers: {
      'Content-Type': 'application/json',
    },
    params: {
      token: accessToken,
      ...params,
    },
    ...options,
  })

  clearTimeout(id)

  return response
}

function useFetch<T>(
  path: string,
  options: AxiosRequestConfig = {},
  inputs: DependencyList = [],
  params: any = {},
): [boolean, any, Error | null] {
  const { authLoading, getIdTokenClaims } = useAuth0()
  const [isLoading, setLoading] = useState(false)
  const [data, setData] = useState(null)
  const [error, setError] = useState<Error | null>(null)

  useAsyncEffect(async () => {
    try {
      if (!authLoading) {
        setLoading(true)
        const accessToken = await getIdTokenClaims()
        const response = await fetchWithTimeout(path, options, accessToken?.__raw as string, 5000, params)
        setData(response.data)
      }
    } catch (error: any) {
      if (axios.isAxiosError(error)) {
        setError(error)
      } else {
        setError(error)
      }
    } finally {
      setLoading(false)
    }
  }, [...inputs, authLoading])

  return [isLoading, data, error]
}

export default useFetch
